export default {
	'add-new-company-value': '',
	'the-company-value': '',
	'company-value': '',
}